// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { Pie } from "react-chartjs-2";
import { createFalse } from "typescript";

const PieChartOptions = {
  maintainAspectRatio: false,
  title: {
    display: false,
    text: "Gender Breakdown"
  },
  legend: {
    onClick: null
  },
  tooltips: {
    //displayColors: false,
    callbacks: {
      title: function(tooltipItem){
        return this._data.labels[tooltipItem[0].index]
      },
      label: function(tooltipItem){
        let value = this._data.datasets[0].data[tooltipItem.index]
        let percentage = value / 289; // MAKE SURE TO CHANGE THIS WITH TOTAL STUDENT COUNT
        let percentString = percentage.toLocaleString('en-US', {
          style: 'percent',
          maximumFractionDigits: 0,
        });
        let valString = value + ' students';
        return valString +', ' +  percentString
      }
    }
  }
};

interface PieChartProps {
  caption: Array<string>;
}

class StaffGenderBreakdownCard extends React.Component<PieChartProps>{
  constructor(props: PieChartProps){
    super(props);
  }
  state = {
    //using this as the data
    //hardcoded this year bc we couldn't make google sheets work
    type: "pie",
    labels: ["Woman", "Man", "Nonbinary", "Prefer not to say"],
    datasets: [
      {
        data: [214, 70, 2, 3],
        backgroundColor: ["#48A2D3", "#F0A202", "#5DBD5B", "#733B90", "#E84855"],
      },
    ]
  };
  render() {
    const caption = this.props.caption
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Staff gender<sup className = {css`display: inline; font-size: 18px`}>*</sup> breakdown
        </div>
        <div
          className={css`
            height: 300px;
            width: 100%;
          `}
        >
          <Pie
            data={this.state}
            options={{
              ...PieChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}
        >
        {caption}
        <p className={css`font-size: 12px;`}>*Categories for gender were self-assigned.</p>
        </div>
      </Card>
    );
  }
}

export default StaffGenderBreakdownCard;
